<ng-template #contentHeaderTemplate></ng-template>

<app-table
  id="dashboard.quality-management.documents.index"
  [showEditLink]="false"
  [functionList]="tableFunctionList"
></app-table>
